/* =========================================================
   AS4 POLYMER -- theme.js
   Vanilla JS, no dependencies. All motion respects
   prefers-reduced-motion. Every enhancement degrades to a
   working native form/link if JS fails.
   ========================================================= */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  var AS4 = (window.AS4 = window.AS4 || {});
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  // Attaches a listener at most once per element+event. The theme editor
  // re-runs boot() on shopify:section:load, and without this a click would
  // fire twice (open then immediately close an accordion, double-step a qty).
  var bindSeq = 0;
  function bindOnce(el, ev, fn, opts) {
    if (!el) return;
    var key = '_as4bound_' + ev;
    if (el[key]) return;
    el[key] = ++bindSeq;
    el.addEventListener(ev, fn, opts);
  }

  /* ---------------------------------------------------------
     Money formatting (mirrors Shopify's money_format)
     --------------------------------------------------------- */
  function fmtNumber(cents, precision, thousands, decimal) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var num = (parseInt(cents, 10) || 0) / 100;
    var parts = num.toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  AS4.formatMoney = function (cents) {
    var fmt = AS4.moneyFormat || '${{amount}}';
    var out = fmt;
    var patterns = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_apostrophe_separator: [2, "'", '.']
    };
    Object.keys(patterns).forEach(function (key) {
      var re = new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g');
      if (re.test(fmt)) {
        var p = patterns[key];
        out = fmt.replace(re, fmtNumber(cents, p[0], p[1], p[2]));
      }
    });
    return out;
  };

  /* ---------------------------------------------------------
     Scroll reveal
     --------------------------------------------------------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------
     Sticky header state
     --------------------------------------------------------- */
  var windowBooted = false;

  function initHeader() {
    var hdr = $('[data-header]');
    if (!hdr) return;
    if (windowBooted) return;
    var ticking = false;
    function update() {
      hdr.classList.toggle('is-stuck', window.scrollY > 12);
      ticking = false;
    }
    update();
    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
  }

  /* ---------------------------------------------------------
     Generic open/close panels (mobile nav, drawer)
     --------------------------------------------------------- */
  var lastFocused = null;

  function lockScroll(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openPanel(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var focusable = el.querySelector('button, [href], input, select, textarea');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.mnav.is-open') && !$('.drawer.is-open')) lockScroll(false);
    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
  }

  on(document, 'keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = $('.drawer.is-open') || $('.mnav.is-open');
    if (open) closePanel(open);
    var sp = $('.search-panel.is-open');
    if (sp) sp.classList.remove('is-open');
  });

  /* ---------------------------------------------------------
     Mobile navigation
     --------------------------------------------------------- */
  function initMobileNav() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    $$('[data-menu-open]').forEach(function (b) { bindOnce(b, 'click', function () { openPanel(nav); }); });
    $$('[data-menu-close]').forEach(function (b) { bindOnce(b, 'click', function () { closePanel(nav); }); });

    $$('[data-submenu-toggle]', nav).forEach(function (btn) {
      bindOnce(btn, 'click', function () {
        var sub = btn.parentElement.parentElement.querySelector('[data-submenu]');
        if (!sub) return;
        var open = sub.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------
     Search panel
     --------------------------------------------------------- */
  function initSearch() {
    var panel = $('[data-search-panel]');
    if (!panel) return;
    $$('[data-search-open]').forEach(function (btn) {
      bindOnce(btn, 'click', function () {
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var input = panel.querySelector('input[type="search"]');
        if (open && input) input.focus();
      });
    });
    $$('[data-search-close]').forEach(function (btn) {
      bindOnce(btn, 'click', function () { panel.classList.remove('is-open'); });
    });
  }

  /* ---------------------------------------------------------
     FAQ accordion
     --------------------------------------------------------- */
  function initFaq() {
    $$('[data-faq-toggle]').forEach(function (btn) {
      bindOnce(btn, 'click', function () {
        var item = btn.closest('.faq-item');
        var panel = item.querySelector('.faq-item__a');
        var isOpen = item.classList.contains('is-open');
        var group = item.closest('.faq__list');

        if (group) {
          $$('.faq-item.is-open', group).forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            other.querySelector('.faq-item__a').style.maxHeight = '';
            other.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
          });
        }

        if (isOpen) {
          item.classList.remove('is-open');
          panel.style.maxHeight = '';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    if (!windowBooted) {
      on(window, 'resize', function () {
        $$('.faq-item.is-open .faq-item__a').forEach(function (p) { p.style.maxHeight = p.scrollHeight + 'px'; });
      });
    }
  }

  /* ---------------------------------------------------------
     Media galleries (product page + homepage showcase)
     --------------------------------------------------------- */
  function initGalleries() {
    $$('[data-gallery]').forEach(function (gallery) {
      var stage = gallery.querySelector('[data-gallery-main]');
      if (!stage) return;
      $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        bindOnce(thumb, 'click', function () {
          $$('[data-gallery-thumb]', gallery).forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-current', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-current', 'true');
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;
          stage.style.opacity = '0';
          window.setTimeout(function () {
            stage.src = src;
            if (srcset) stage.srcset = srcset;
            stage.alt = alt;
            stage.style.opacity = '1';
          }, reduced ? 0 : 140);
        });
      });
    });
  }

  /* ---------------------------------------------------------
     Quantity steppers
     --------------------------------------------------------- */
  function stepperFor(btn) { return btn.parentElement.querySelector('input'); }

  function initSteppers(ctx) {
    $$('[data-qty-down]', ctx).forEach(function (b) {
      bindOnce(b, 'click', function () {
        var input = stepperFor(b);
        var min = parseInt(input.getAttribute('min') || '1', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    $$('[data-qty-up]', ctx).forEach(function (b) {
      bindOnce(b, 'click', function () {
        var input = stepperFor(b);
        input.value = (parseInt(input.value, 10) || 1) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------------------------------------------------------
     Toast
     --------------------------------------------------------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.querySelector('[data-toast-text]').textContent = msg;
    el.classList.add('is-on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }
  AS4.toast = toast;

  /* ---------------------------------------------------------
     Cart
     --------------------------------------------------------- */
  var drawer = null;

  function renderDrawer(cart) {
    var body = $('[data-drawer-body]');
    var foot = $('[data-drawer-foot]');
    var sub = $('[data-drawer-subtotal]');
    if (!body) return;

    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-empty', cart.item_count === 0 ? 'true' : 'false');
    });

    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer__empty"><p>' + (AS4.strings.cartEmpty || 'Your cart is empty.') +
        '</p><a class="btn btn--nav" href="' + (AS4.routes.all || '/collections/all') + '">' +
        (AS4.strings.continueShopping || 'Continue shopping') + '</a></div>';
      if (foot) foot.hidden = true;
      return;
    }

    if (foot) foot.hidden = false;
    if (sub) sub.textContent = AS4.formatMoney(cart.total_price);

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2') + '" alt="" width="64" height="64" loading="lazy">'
        : '<span></span>';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<p class="dline__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      return '<div class="dline" data-line="' + item.key + '">' + img +
        '<div><a href="' + item.url + '"><p class="dline__title">' + escapeHtml(item.product_title) + '</p></a>' +
        variant +
        '<div class="dline__row">' +
          '<div class="qty qty--sm">' +
            '<button type="button" data-qty-down aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" min="0" value="' + item.quantity + '" data-line-qty="' + item.key + '" aria-label="Quantity">' +
            '<button type="button" data-qty-up aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<span class="price">' + AS4.formatMoney(item.final_line_price) + '</span>' +
        '</div></div></div>';
    }).join('');

    initSteppers(body);
    $$('[data-line-qty]', body).forEach(function (input) {
      on(input, 'change', function () {
        changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10) || 0);
      });
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchCart() {
    return fetch(AS4.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refreshCart() {
    if (!window.fetch) return Promise.resolve();
    return fetchCart().then(renderDrawer).catch(function () {});
  }

  function changeLine(key, quantity) {
    if (!window.fetch) return;
    fetch(AS4.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () { window.location.href = AS4.routes.cart; });
  }

  function initCart() {
    drawer = $('[data-cart-drawer]');
    $$('[data-cart-open]').forEach(function (btn) {
      bindOnce(btn, 'click', function (e) {
        if (!drawer || !window.fetch) return; // fall back to the cart page link
        e.preventDefault();
        openPanel(drawer);
        refreshCart();
      });
    });
    $$('[data-cart-close]').forEach(function (b) { bindOnce(b, 'click', function () { closePanel(drawer); }); });

    // Cart page line controls
    $$('[data-cart-line-qty]').forEach(function (input) {
      bindOnce(input, 'change', function () {
        changeLine(input.getAttribute('data-cart-line-qty'), parseInt(input.value, 10) || 0);
      });
    });
    $$('[data-cart-remove]').forEach(function (btn) {
      bindOnce(btn, 'click', function (e) {
        e.preventDefault();
        changeLine(btn.getAttribute('data-cart-remove'), 0);
      });
    });

    initSteppers(document);
    if (drawer && window.fetch) refreshCart();
  }

  function addToCart(form, button) {
    if (!window.fetch) { form.submit(); return; }
    var original = button ? button.innerHTML : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); }

    fetch(AS4.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (button) button.removeAttribute('aria-disabled');
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'Could not add to cart.');
          return;
        }
        if (button) {
          button.classList.add('is-added');
          button.innerHTML = AS4.strings.added || 'Added';
          window.setTimeout(function () {
            button.classList.remove('is-added');
            button.innerHTML = original;
          }, 1800);
        }
        return refreshCart().then(function () {
          if (drawer) openPanel(drawer); else toast(AS4.strings.added || 'Added to cart');
        });
      })
      .catch(function () { form.submit(); });
  }

  /* ---------------------------------------------------------
     Product form -- variants, price, availability, media, URL
     --------------------------------------------------------- */
  function initProductForm() {
    $$('[data-product-root]').forEach(function (rootEl) {
      var dataEl = rootEl.querySelector('[data-variant-json]');
      var form = rootEl.querySelector('form.as4-pform') || rootEl.querySelector('[data-product-form]');
      if (!dataEl || !form) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      if (!variants || !variants.length) return;

      var idInput = form.querySelector('[data-variant-id]');
      var atc = rootEl.querySelector('[data-atc]');
      var atcText = atc ? atc.querySelector('[data-atc-text]') : null;
      var priceEl = rootEl.querySelector('[data-price]');
      var compareEl = rootEl.querySelector('[data-price-compare]');
      var saveEl = rootEl.querySelector('[data-price-save]');
      var stage = rootEl.querySelector('[data-gallery-main]');
      var barPrice = document.querySelector('[data-buybar-price]');
      var barBtn = document.querySelector('[data-buybar-add]');

      function selectedValues() {
        return $$('[data-option-group]', rootEl).map(function (group) {
          var chosen = group.querySelector('[data-option-value].is-selected');
          return chosen ? chosen.getAttribute('data-value') : null;
        });
      }

      function findVariant(values) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < values.length; j++) {
            if (values[j] === null) { match = false; break; }
            if (v.options[j] !== values[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      // Mark option values that lead to no purchasable variant
      function markAvailability(values) {
        $$('[data-option-group]', rootEl).forEach(function (group, gi) {
          $$('[data-option-value]', group).forEach(function (btn) {
            var probe = values.slice();
            probe[gi] = btn.getAttribute('data-value');
            var exists = variants.some(function (v) {
              return probe.every(function (val, k) { return val === null || v.options[k] === val; }) && v.available;
            });
            btn.classList.toggle('is-unavailable', !exists);
          });
        });
      }

      function update(pushUrl) {
        var values = selectedValues();
        markAvailability(values);
        var variant = findVariant(values);

        if (!variant) {
          if (idInput) idInput.value = '';
          if (atc) { atc.setAttribute('aria-disabled', 'true'); }
          if (atcText) atcText.textContent = AS4.strings.unavailable || 'Unavailable';
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceEl) priceEl.textContent = AS4.formatMoney(variant.price);
        if (barPrice) barPrice.textContent = AS4.formatMoney(variant.price);

        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) {
          compareEl.hidden = !onSale;
          if (onSale) compareEl.textContent = AS4.formatMoney(variant.compare_at_price);
        }
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) {
            var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            saveEl.textContent = (AS4.strings.save || 'Save') + ' ' + pct + '%';
          }
        }

        if (atc) {
          if (variant.available) {
            atc.removeAttribute('aria-disabled');
            if (atcText) atcText.textContent = AS4.strings.addToCart || 'Add to cart';
            if (barBtn) barBtn.removeAttribute('aria-disabled');
          } else {
            atc.setAttribute('aria-disabled', 'true');
            if (atcText) atcText.textContent = AS4.strings.soldOut || 'Sold out';
            if (barBtn) barBtn.setAttribute('aria-disabled', 'true');
          }
        }

        // Swap gallery to the variant's image
        if (stage && variant.featured_image && variant.featured_image.src) {
          var fid = variant.featured_image.id;
          var thumb = rootEl.querySelector('[data-gallery-thumb][data-image-id="' + fid + '"]')
                   || rootEl.querySelector('[data-gallery-thumb][data-media-id="' + fid + '"]');
          if (thumb) { thumb.click(); }
          else { stage.src = variant.featured_image.src; stage.removeAttribute('srcset'); }
        }

        if (pushUrl && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      $$('[data-option-group]', rootEl).forEach(function (group) {
        $$('[data-option-value]', group).forEach(function (btn) {
          bindOnce(btn, 'click', function () {
            $$('[data-option-value]', group).forEach(function (b) {
              b.classList.remove('is-selected');
              b.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
            var label = group.parentElement.querySelector('[data-option-selected]');
            if (label) label.textContent = btn.getAttribute('data-value');
            update(true);
          });
        });
      });

      bindOnce(form, 'submit', function (e) {
        e.preventDefault();
        addToCart(form, atc);
      });

      if (barBtn) {
        bindOnce(barBtn, 'click', function () { addToCart(form, atc); });
      }

      update(false);
    });
  }

  /* ---------------------------------------------------------
     Sticky buy bar
     --------------------------------------------------------- */
  function initBuyBar() {
    var bar = $('[data-buybar]');
    var anchor = $('[data-buybar-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------------------------------------------------------
     Subtle parallax (lifestyle band)
     --------------------------------------------------------- */
  function initParallax() {
    var els = $$('[data-parallax]');
    if (!els.length || reduced || windowBooted) return;
    var ticking = false;
    function frame() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        var img = el.querySelector('img') || el;
        img.style.transform = 'translate3d(0,' + (progress * -26).toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }, { passive: true });
    frame();
  }

  /* ---------------------------------------------------------
     Collection sorting (native select, no JS dependency for value)
     --------------------------------------------------------- */
  function initSort() {
    var select = $('[data-sort]');
    if (!select) return;
    bindOnce(select, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------------------------------------------------------
     Boot
     --------------------------------------------------------- */
  function boot() {
    initReveal();
    initHeader();
    initMobileNav();
    initSearch();
    initFaq();
    initGalleries();
    initCart();
    initProductForm();
    initBuyBar();
    initParallax();
    initSort();
    windowBooted = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', function () { initReveal(); });
})();
